define(() => {
    const features = require('Cloud/Application/Features');
    const socialIconsStatistics = require('Cloud/Application/SocialIconsStatistics');
    const BSocialIcons = require('blocks-cloud/b-social-icons/b-social-icons');
    const BMobileShare = require('blocks-cloud/b-mobile-share/b-mobile-share');
    const config = require('Cloud/config');
    const browser = require('Cloud/browser');

    return function (app) {
        // Используется только для телефонов
        const IS_WEBVIEW = config.get('IS_WEBVIEW');
        const IS_MOBILE = config.get('MOBILE_BROWSER');
        const isNativeShareSupported = IS_MOBILE && 'share' in navigator && typeof navigator.share === 'function';
        const IS_DARK_PUBLIC_VIEW_ENABLED = features.isFeature('dark-public-file') || !IS_MOBILE;

        var socialIcons = new BSocialIcons({
            el: '#social-icons',
            template: 'app',
            templateBlock: 'b-social-icons',

            render: function () {
                var params = {
                    block: 'b-social-icons',
                    socials: (app.social && app.social.list) || [],
                    mods: ['horizontal', 'phone'],
                    showTitle: false,
                };

                this.setData(params);

                this.$el.toggleClass('public__content__social-icons');
                this.toggleMod('phone', true);

                patron.toolkit['b-social-icons'].fn.render.call(this);
            },
            empty: function () {
                patron.toolkit['b-social-icons'].fn.empty.call(this);

                this.toggleMod('phone', false);
                this.$el.removeClass('public__content__social-icons');
            },
            onSocial: function (event, ui) {
                var item = app.current() || {}; // легко вернет undefined;

                app.social.publishItem(ui.id, item);

                socialIconsStatistics.send({
                    item: item,
                    platform: app.browser.getPlatform(),
                    storage: app.getStorage(),
                    sendKaktam: true,
                    isFile: app.isChoosedPublicFile(),
                    isShoved: false,
                    service: ui.id,
                    socialIconsView: 'content',
                });

                socialIconsStatistics.sendGoogleAnalytics({
                    isFile: app.isChoosedPublicFile(),
                    isShoved: false,
                    service: ui.id,
                    socialIconsView: 'content',
                });
            },
        });

        var shareEl = document.querySelector('.' + BMobileShare.prototype.bemName);

        if (shareEl) {
            var mobileShare = new BMobileShare({
                el: shareEl,
                data: {
                    isWebview: IS_WEBVIEW,
                    isNativeShare: isNativeShareSupported,
                },
            });

            app.on('routeEnd', function () {
                var currentItem = app.current();
                const newPublic = IS_DARK_PUBLIC_VIEW_ENABLED;

                RADAR.ga('send', 'event', {
                    eventCategory: `public-file-view${newPublic ? '' : '-old'}`,
                    eventAction: 'mob-ln-show',
                });

                if (newPublic) {
                    return;
                }

                mobileShare.show();

                socialIcons.render();

                if (currentItem) {
                    mobileShare.setWide(!app.isFolder(currentItem));
                }

                if (!IS_WEBVIEW) {
                    const url = app.isFolder(currentItem) ? 'https://trk.mail.ru/c/gmcec7' : 'https://trk.mail.ru/c/vw8xj9';
                    mobileShare.changeInAppUrl(url + '?mt_deeplink=', window.location.href);
                }
            });

            var EMORB_VENDOR = 'vendor-' + (config.get('EMORB_VENDOR').replace(/[ _]/g, '-').toLowerCase() || 'unknown');
            var EMORB_DTID = 'dtid-' + (config.get('EMORB_DTID').replace(/[ _]/g, '-').toLowerCase() || 'unknown');
            var EMORB_OS = 'os-' + (config.get('EMORB_OS').replace(/[ _]/g, '-').toLowerCase() || 'unknown');
            var EMORB_SCREENSIZE = 'screen-' + (config.get('EMORB_SCREENSIZE').replace(/[ _]/g, '-').toLowerCase() || 'unknown');

            var groupName = 'deeplink-public';
            var radar = RADAR.group(groupName);

            radar.add('show_' + EMORB_VENDOR);
            radar.add('show_' + EMORB_DTID);
            radar.add('show_' + EMORB_OS);
            radar.add('show_' + EMORB_SCREENSIZE);
            radar.add('show_all');
            radar.send();

            $(document).delegate('.b-deeplink-banner a', 'click', function (e) {
                e.preventDefault();
                var link = this;

                var radar = RADAR.group(groupName);

                radar.add('click_' + EMORB_VENDOR);
                radar.add('click_' + EMORB_DTID);
                radar.add('click_' + EMORB_OS);
                radar.add('click_' + EMORB_SCREENSIZE);
                radar.add('click_all');
                radar.send();

                setTimeout(function () {
                    window.location = link.href;
                }, 100);
            });
        }

        return socialIcons;
    };
});
